import commonMixin from '@/mixin/common'
import Menu from '@/components/Menu'
import Tabbar from '@/components/Tabbar'
import {articleAll} from '@/api/server/article'
import {getItem} from '@/utils/storage'
export default {
  name: 'userPage',
  mixins: [commonMixin],
  data () {
    return {
      articles: [],
      phone: null
    }
  },
  components: {
    Menu,
    Tabbar
  },
  computed: {
  },
  methods: {
    _getContactPhone () {
      let phone = getItem('acting-phone')
      if (phone) {
        this.phone = phone
      } else {
        this.phone = ''
      }
    },
    _getArticleAll () {
      articleAll().then( (res) => {
        if (res.code === 200 && res.data) {
          this.articles = res.data
        }
      })
    },
    reset () {
      this._getArticleAll()
      this._getContactPhone()
    },
    handleRoute (route) {
      if (route.name === 'user') {
        console.log('user')
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}